import { useState, useEffect, useCallback } from 'react';
import { router } from '@inertiajs/react';
import { useSurveyDismissed } from './useSurveyDismissed';

const FOCUS_SECONDS = 20;

export const useRatesSurvey = () => {
  const [dismissed, setDismissed] = useSurveyDismissed();
  const [focusTime, setFocusTime] = useState(0);
  const [isOnRates, setIsOnRates] = useState(() => window.location.pathname.includes('/rates'));

  useEffect(() => {
    const removeListener = router.on('navigate', (event) => {
      const url = event.detail.page.url;
      setIsOnRates(url.includes('/rates'));
    });
    return () => removeListener();
  }, []);

  useEffect(() => {
    if (!isOnRates || dismissed) return;

    const interval = setInterval(() => {
      if (document.hasFocus()) {
        setFocusTime((prev) => prev + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isOnRates, dismissed]);

  const show = !dismissed && isOnRates && focusTime >= FOCUS_SECONDS;

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, [setDismissed]);

  return { show, dismiss };
};
